var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offline"},[_c('div',{staticClass:"offline-box"},[_c('div',{staticClass:"offline-title"},[_c('span',[_vm._v("cardboard")]),_c('span',[_vm._v("events")])]),_c('p',[_vm._v("The website is currently being updated and will be back shortly. We apologize for the inconvenience.")])])])
}]

export { render, staticRenderFns }